import React from 'react';

import Title from '../../components/Title/Title';
import Pergunta from '../../components/Pergunta/Pergunta';

import useStyles from './Style';

const Olimpiada = () => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-01" className={classes.title}>
                OLIMPÍADA DE PROFESSORES DA OBMEP MIRIM
            </Title>

            <Pergunta pergunta="Qual o objetivo da Olimpíada de Professores da OBMEP Mirim ?">
                Aprimorar as habilidades dos professores do Ensino Fundamental I na resolução de questões de natureza olímpica e estimular a participação dos alunos na OBMEP Mirim por meio da atuação direta de seus professores.
            </Pergunta>

            <Pergunta pergunta="Quem pode participar da Olimpíada de Professores da OBMEP Mirim?">
                Professores que tenham matrícula ativa em escolas públicas (municipais, estaduais e federais) ou privadas localizadas no território brasileiro e ministrem aulas para alunos do 1º, 2º 3º 4º e ou 5º ano do Ensino Fundamental I.
            </Pergunta>
        </>
    )
}

export default Olimpiada;